module.exports = __webpack_public_path__ + "images/analysis-423a030f.svg";